import { ComponentType, createContext, PropsWithChildren, useMemo } from "react";
import { useSelector } from "react-redux";

import { Model, ModelSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/model";
import {
	DocumentModel,
	DocumentModelSearchService,
	DocumentServiceFactory
} from "@com.mgmtp.a12.kernel/kernel-md-facade";

const documentServiceFactory = new DocumentServiceFactory();

export const DocumentModelContext = createContext<
	| {
			readonly documentModel: DocumentModel;
			readonly documentModelSearchService: DocumentModelSearchService;
	  }
	| undefined
>(undefined);

type DocumentModelContextProviderProps = PropsWithChildren<{ readonly activityId: string }>;
export const DocumentModelContextProvider: ComponentType<DocumentModelContextProviderProps> = function Provider({
	activityId,
	children
}) {
	const documentModel = useSelector(
		ModelSelectors.modelInScene({ activityId, modelType: "document" }, Model.isDocumentModel)
	);

	const value = useMemo(
		() =>
			documentModel
				? {
						documentModel,
						documentModelSearchService: documentServiceFactory.getDocumentModelSearchService(documentModel)
					}
				: undefined,
		[documentModel]
	);

	return <DocumentModelContext.Provider value={value}>{children}</DocumentModelContext.Provider>;
};
